<template>

  <a-table
    ref="table"
    size="middle"
    :scroll="{x:true}"
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
    :customHeaderRow="customHeaderRow"
    :customRow="customRow"
    class="j-table-force-nowrap"
    @change="handleTableChange">

      <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
        <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-if="column.dataIndex!='headImg' && column.dataIndex !='phone'">{{text || '-'}}</div>
          <div v-else-if="column.dataIndex =='phone'">
            <img src="@/assets/driver/wx_lv.png" style="width: 16px;margin-right: 5px" v-if="record.wxFlag==1"/>
            <icon-font type="icon-shoujihaoma" style="font-size: 16px;margin-right: 5px" v-if="record.wxFlag==0"></icon-font>
            <span>{{text || '-'}}</span>
          </div>
          <div v-else>
            <span v-if="!text">-</span>
            <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;border-radius:50%"/>
          </div>
        </slot>
      </template>

  </a-table>

</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'
  export default {
    name: 'PhoneTable',
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      }
    },data(){
      return {
        columns: [
          {
            title: '手机号',
            dataIndex: 'phone',
            width:180,
            fixed:'left',
            align:"center",
            scopedSlots: { customRender: 'phoneSlot' },
          },
          {
            title:'号码标记',
            align:"center",
            width:140,
            dataIndex: 'phrases',
            scopedSlots: { customRender: 'phrasesSlot' },
          },
          {
            title:'主叫人',
            align:"center",
            width:180,
            dataIndex: 'headImg',
            scopedSlots: {customRender: 'imgSlot'}
          },
          {
            title:'最近通话时间',
            align:"center",
            width:240,
            dataIndex: 'lastCallTime',
            scopedSlots: { customRender: 'lastCallTimeSlot' },
          },
          {
            title: '备注',
            align:"center",
            width:200,
            fixed:'right',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remarkSlot' },
          }
        ],
        url: {
          list: "/dm/dmDriverPhone/list"
        },disableMixinCreated:true
      }
    },methods:{
     loadList(){
        this.queryParam.driverId = this.driverId;
        this.loadData();
      },viewInfo(record){
        this.$emit("to",record);
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/dm/newTable.less';
  /deep/ .hui-class td{
    color: #91929e !important;
  }
</style>